import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const tilledApi = createApi({
  reducerPath: "tilled",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["TilledAccounts", "TilledPayments" ],
  endpoints: (builder) => ({

    // ── Accounts ────────────────────────────────────────────────────────────────────────────────
    getAllAccounts: builder.query({
      query: ({ page = 1, limit = 10, keyword = "" } = {}) => {
        let url = `/tilled/accounts?page=${page}&limit=${limit}`;
        if (keyword) url += `&keyword=${keyword}`;
        return { url, method: "GET" };
      },
      providesTags: ["TilledAccounts"],
    }),
    getTilledAccount: builder.query({
      query: () => ({
        url: `/contractor/tilled/account/details`,
        method: "GET",
      }),
      providesTags: ["TilledAccounts"],
    }),
    createOnboardingLink: builder.mutation({
      query: (data) => ({
        url: `/contractor/tilled/onboarding`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["TilledPayments" ,"TilledAccounts"],
    }),
    createPaymentMethod: builder.mutation({
      query: (data) => ({
        url: `/contractor/tilled/payment_method`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["TilledPayments"],
    }), 
    confirmPayment: builder.mutation({
      query: (data) => ({
        url: `/contractor/tilled/confirm_payment_intent`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["Invoice", "TilledPayments"],
     }),
    savePayment: builder.mutation({
      query: (data) => ({
        url: `/contractor/tilled/save_payment`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["Invoice", "TilledPayments"],
     }),
     createPaymentIntent : builder.mutation({
      query: (data) => ({
        url: `/contractor/tilled/create_payment_intent`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: data,
      }),
      invalidatesTags: ["Invoice", "TilledPayments"],
     }),
  }),
});

export const {
  useGetAllAccountsQuery,
  useGetTilledAccountQuery,
  useCreateOnboardingLinkMutation,
  useCreatePaymentMethodMutation,
  useCreatePaymentIntentMutation,
  useConfirmPaymentMutation,
  useSavePaymentMutation,
} = tilledApi;